// Configuración compartida del menú admin — una sola fuente para el sidebar
// de PC, el sheet "Más" de móvil y la barra inferior de móvil, así que un
// enlace nuevo solo se agrega aquí y aparece en los tres lugares.
import {
  HomeIcon,
  UserGroupIcon,
  UserIcon,
  DocumentTextIcon,
  ClipboardDocumentIcon,
  WrenchScrewdriverIcon,
  ChartBarIcon,
  CalendarDaysIcon,
  UserCircleIcon,
  ChatBubbleLeftRightIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  MegaphoneIcon,
  Cog6ToothIcon,
  ServerIcon,
  MagnifyingGlassIcon,
  LinkIcon,
} from '@heroicons/react/24/outline';

export const NAV_GROUPS = [
  {
    label: 'Principal',
    items: [
      { name: 'Dashboard', icon: HomeIcon, to: '/admin/dashboard' },
      { name: 'Clientes', icon: UserGroupIcon, to: '/admin/clients' },
      { name: 'Agenda', icon: CalendarDaysIcon, to: '/admin/calendar' },
      // Bandeja unificada de WhatsApp/Messenger/Email — no confundir con el
      // botón flotante de chat con clientes (AdminMessagingLauncher), que es
      // otra cosa y ya tiene su propia burbuja fija en pantalla.
      { name: 'Mensajería', icon: ChatBubbleLeftRightIcon, to: '/admin/whatsapp' },
    ],
  },
  {
    label: 'Ventas',
    items: [
      { name: 'Leads', icon: UserIcon, to: '/admin/leads' },
      { name: 'Ventas', icon: ChartBarIcon, to: '/admin/sales' },
      { name: 'Facturas', icon: DocumentTextIcon, to: '/admin/invoices-global' },
      { name: 'Propuestas', icon: ClipboardDocumentIcon, to: '/admin/proposals-global' },
    ],
  },
  {
    label: 'Operaciones',
    items: [
      { name: 'Servicios', icon: WrenchScrewdriverIcon, to: '/admin/services' },
      { name: 'Equipo', icon: UserCircleIcon, to: '/admin/team' },
      { name: 'Hosting', icon: ServerIcon, to: '/admin/hosting' },
    ],
  },
  {
    label: 'Mercadeo',
    items: [
      { name: 'Campañas', icon: MegaphoneIcon, to: '/admin/marketing/campanas' },
      { name: 'Email Studio', icon: DocumentTextIcon, to: '/admin/marketing' },
      { name: 'Prospección', icon: UserGroupIcon, to: '/admin/marketing/prospeccion' },
      { name: 'Contenido y pauta', icon: ChartBarIcon, to: '/admin/marketing/meta-ads' },
      { name: 'Landing Studio', icon: DocumentTextIcon, to: '/admin/marketing/landings' },
      { name: 'SEO y demanda', icon: MagnifyingGlassIcon, to: '/admin/seo' },
    ],
  },
  {
    label: 'Configuración',
    items: [
      { name: 'Clover', icon: Cog6ToothIcon, to: '/admin/settings/clover' },
      { name: 'Conexiones e integraciones', icon: LinkIcon, to: '/admin/settings/marketing' },
      { name: 'Mi perfil', icon: UserCircleIcon, to: '/admin/profile' },
    ],
  },
];

// No es una ruta — abre el mismo panel flotante de conversaciones con
// clientes que ya existía (AdminMessagingLauncher, con su badge de no
// leídos), distinto de la bandeja de WhatsApp/Messenger/Email de abajo.
export const CLIENT_CHAT_ITEM = { name: 'Chat clientes', icon: ChatBubbleOvalLeftEllipsisIcon, action: 'messaging' };

// Los 4 accesos de más uso diario + "Más" para el resto — pensado para el
// pulgar en la barra inferior de móvil. Las dos mensajerías (bandeja externa
// y chat de clientes) son herramientas distintas, así que ambas quedan como
// accesos primarios — Agenda pasa al sheet "Más".
export const MOBILE_PRIMARY_ITEMS = [
  { name: 'Dashboard', icon: HomeIcon, to: '/admin/dashboard' },
  { name: 'Clientes', icon: UserGroupIcon, to: '/admin/clients' },
  { name: 'Mensajería', icon: ChatBubbleLeftRightIcon, to: '/admin/whatsapp' },
  CLIENT_CHAT_ITEM,
];
